<!-- 论文要求查看 -->
<template>
    <div class="el-Require">
        <el-row class="page_content">
            <h1 class="head_title">论文 AI 评审</h1>
            <div style="margin-bottom: 10px;">
                <el-button type="primary" @click="UploadPaper">上传论文</el-button>
            </div>
            <el-table :data="tableData" border style="width: 100%;">
                <el-table-column type="index" label="序号" width="80" header-align="center" align="center">
                </el-table-column>
                <el-table-column header-align="center" align="center" label="附件名称">
                    <template slot-scope="scope">
                        {{ scope.row.fileName }}
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" header-align="center" align="center" label="创建时间">
                </el-table-column>
                <el-table-column prop="status" header-align="center" align="center" label="评审结果">
                    <template slot-scope="scope">
                        <span style="color:orange;" v-if="scope.row.status == 0">评审中</span>
                        <span style="color:#1890ff;" v-if="scope.row.status == 1">评审完成</span>
                        <span style="color:red;" v-if="scope.row.status == 3">评审失败</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" header-align="center" align="center" label="操作" width="200">
                    <template slot-scope="scope">
                        <span style="color:#1890ff;" v-if="scope.row.status == 1">
                            <a @click="getFile(scope.row.dimensionFileUrl,scope.row.fileName)" style="color:#1890ff;cursor:pointer;">下载结果</a>
                        </span>
                        <template v-else>
                            -
                        </template>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>

        <el-dialog title="论文上传" :visible.sync="dialogVisible" width="700px">
          <el-form ref="form" label-position="right" :model="form" label-width="100px">
            <el-form-item label="论文上传：" style="margin-bottom: 0;">
              <el-upload class="avatar-uploader" :action="uploadUrl" :headers="headers" :show-file-list="false"
                    accept=".pdf,.doc,.docx"
                  :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :disabled="disabledset">
                  <el-button size="small" type="primary" :disabled="disabledset">点击上传</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item label="">
                <span style="color: #f53b3b;">注：只能上传pdf / doc / docx</span>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
          </span>
        </el-dialog>
    </div>
</template>
<script>
import { getCookieForRoleTag } from '../../common/ulit'
export default {
    name: "ask",
    data() {
        return {
            uploadUrl: this.$baseUrl + "/api/student/huaczyUpload.do", //请求接口
            headers: { token: getCookieForRoleTag(), "_role_tag": getCookieForRoleTag() ? getCookieForRoleTag().split(".")[getCookieForRoleTag().split(".").length - 1] : null }, //请求头
            tableData: [],
            dialogVisible: false,
            form:{
                proposalFileName: '',
            },
            disabledset: false,
            timer:null,
            uploadLoading:null,
        };
    },
    created() {

    },
    mounted() {
        this.getTable();
        this.timer = setInterval(() => {
            this.getTable();
        }, 60000);
    },
    methods: {
        getTable() {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$store.dispatch("thesis/huaczyList").then((ret) => {
                loading.close();
                if (ret.code == 0) {
                    this.tableData = ret.data

                } else {
                    this.$message.error(ret.msg);
                }
            }).catch((err) => {
                loading.close();
            });
        },
        UploadPaper(){
            this.dialogVisible = true;
        },
        beforeAvatarUpload(file) {
              // 1. 验证文件类型
              const allowedMimeTypes = [
                "application/pdf",
                "application/msword",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
              ];
              const fileExtension = file.name
                .slice(file.name.lastIndexOf(".") + 1)
                .toLowerCase();

              const isTypeValid = allowedMimeTypes.includes(file.type);
              const isExtensionValid = ["pdf", "doc", "docx"].includes(fileExtension);

              if (!isTypeValid || !isExtensionValid) {
                this.$message.error("文件类型不支持！");
                return false;
              }

              // 2. 可选：验证文件大小（例如限制 10MB）
              // const isSizeValid = file.size / 1024 / 1024 <= 10;
              // if (!isSizeValid) {
              //   this.$message.error("文件大小不能超过 10MB！");
              //   return false;
              // }
                this.uploadLoading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
              return true;
            },

        handleAvatarSuccess(res, tag) {
            this.uploadLoading.close();
            if (res.code == 0) {
                // this.form.proposalFileName = res.data.title;
                this.$message.success(res.msg);
                this.dialogVisible = false;
                this.getTable();
            }else{
                this.$message.error(res.msg);
            }
        },
        //下载
        getFile(url, name) {
            const a = document.createElement("a");
            const prefix = window.configs.API_ROOT;
            let setturl=prefix+url;
            var first = url.lastIndexOf("."); //取到文件名开始到最后一个点的长度
            var nameL = url.lastIndexOf("/");
            var namelength = url.length; //取到文件名长度
            var filesuffix = url.substring(first + 1, namelength); //截取获得后缀名
            name = name +  '_评审结果' + "." + filesuffix;
            this.$downLoadFile(url,name)

        }
    },beforeDestroy() {
        if(this.timer != null){
            clearInterval(this.timer); // 清除定时器
        }
    }

};
</script>
<style  lang="less">
@import '../../styles/base.less';

.el-Require {
    .wd {
        color: @red;
    }

    // .el-dialog__body{
    //     border-top:1px solid #ebeef5;
    // }
}
</style>



// WEBPACK FOOTER //
// src/pages/transactionPaper/reviewArticle.vue